export const UPDATE_NOTIFICATION_SECONDS = 60000 * 5;
